<div id="chatQualification" class="panel panelQualif">
  <div class="panel-title qualif-panel">
    <h3 class="title">{{ 'agent:contact.workspace.chat.qualification.title' | translate }}</h3>
  </div>

  <cng-qualification-form [booking]="responseId" class="qualification-form"></cng-qualification-form>
</div>
